<div class="op-pagination" *ngIf="pagination && isVisible && pagination.total">
  <nav class="op-pagination--pages" [attr.aria-label]="text.page_navigation">
    <ul class="op-pagination--items op-pagination--items_start" role="presentation">

      <li [hidden]="pagination.page === 1 || !showPageSelections" class="op-pagination--item">
        <button
          class="op-pagination--item-link op-pagination--item-link_prev"
          type="button"
          (click)="showPage(pagination.page - 1)"
          data-rel="prev">
          <svg chevron-left-icon size="xsmall" class="op-pagination--item-link-icon op-pagination--item-link-icon_prev" />
          {{text.label_previous}}
        </button>
      </li>

      <ng-container *ngIf="prePageNumbers.length > 0">
        <li *ngFor="let pageNumber of prePageNumbers"
            class="op-pagination--item">
          <button
            class="op-pagination--item-link"
            type="button"
            (click)="showPage(pageNumber)"
            data-rel="prev"
            [attr.aria-label]="text.page_number(pageNumber)"
            [textContent]="pageNumber"
          ></button>
        </li>
        <li class="op-pagination--space">
          <span class="sr-only" [textContent]="text.pages_skipped"></span>
          <span aria-hidden="true">…</span>
        </li>
      </ng-container>

      <ng-container *ngIf="pageNumbers.length > 1">
        <li *ngFor="let pageNumber of pageNumbers"
            [ngClass]="{ 'op-pagination--item_current': pageNumber === pagination.page }"
            class="op-pagination--item">
          <em
            *ngIf="pageNumber === pagination.page"
            [attr.aria-label]="text.page_number(pageNumber)"
            aria-current="page"
            tabindex="0">
            {{ pageNumber }}
          </em>
          <button
            class="op-pagination--item-link"
            type="button"
            *ngIf="pageNumber !== pagination.page"
            (click)="showPage(pageNumber)"
            data-rel="next"
            [attr.aria-label]="text.page_number(pageNumber)"
            [textContent]="pageNumber"
          ></button>
        </li>
        <li class="op-pagination--space">
          <span class="sr-only" [textContent]="text.pages_skipped"></span>
          <span aria-hidden="true">…</span>
        </li>
      </ng-container>

      <ng-container *ngIf="postPageNumbers.length">
        <li *ngFor="let pageNumber of postPageNumbers" class="op-pagination--item">
          <button
            class="op-pagination--item-link"
            type="button"
            (click)="showPage(pageNumber)"
            data-rel="next"
            [attr.aria-label]="text.page_number(pageNumber)"
            [textContent]="pageNumber"
          ></button>
        </li>
      </ng-container>

      <li [hidden]="!(pagination.total && pagination.page < pageNumbers[pageNumbers.length - 1])"
          class="op-pagination--item">
        <button
          class="op-pagination--item-link op-pagination--item-link_next"
          type="button"
          (click)="showPage(pagination.page + 1)"
          data-rel="next">
          {{text.label_next}}
          <svg chevron-right-icon size="xsmall" class="op-pagination--item-link-icon op-pagination--item-link-icon_next" />
        </button>
      </li>
      <li class="op-pagination--range" aria-live="polite">
        {{currentRange}}
        <span *ngIf="pageNumbers.length === 1"
          id="op-pagination-empty-text"
          tabindex="0"
          class="sr-only"
          [textContent]="text.no_other_page"></span>
      </li>
      <li class="op-pagination--info"
          *ngIf="infoText">
        <op-icon icon-classes="icon-info1 icon-context"></op-icon>
        <span [textContent]="infoText"></span>
      </li>
    </ul>
  </nav>

  <div class="op-pagination--options" *ngIf="showPerPageOptions()">
    <nav [attr.aria-label]="text.per_page_navigation">
      <ul
        class="op-pagination--items op-pagination--items_end"
        role="presentation">
        <li
          class="op-pagination--label"
          [textContent]="text.per_page">
        </li>
        <li
          *ngFor="let perPageOption of perPageOptions"
          class="op-pagination--item"
          [ngClass]="{ 'op-pagination--item_current': perPageOption === pagination.perPage }">
          <button
            *ngIf="perPageOption !== pagination.perPage"
            class="op-pagination--item-link"
            type="button"
            (click)="selectPerPage(perPageOption)"
            [textContent]="perPageOption"
            [attr.aria-label]="text.show_per_page(perPageOption)"
          ></button>
          <span *ngIf="perPageOption === pagination.perPage"
            tabindex="0"
            aria-current="true"
            [attr.aria-label]="text.show_per_page(perPageOption)">
            {{ perPageOption }}
          </span>
        </li>
      </ul>
    </nav>
  </div>
</div>
